import React, { memo } from 'react';
import { PortfolioHOC } from './PortfolioHOC';

const withEditFunctionality = (ChildComponent) =>
  memo(({ ...rest }) => <PortfolioHOC {...{ ChildComponent, ...rest }} />);

export { withEditFunctionality };
